/* eslint-disable jsx-a11y/anchor-is-valid */
import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {SnackbarProvider} from 'notistack'
import {FC, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {InputDate} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {billingSchema} from '../../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {useModules} from '../../../../hooks/useModules'
import {useRooms} from '../../../../hooks/useRooms'
import {BillingDocument, BillingModel} from '../../../../models/billing.model'
import {getListBillingService} from '../../../../services/billing.service'
import {HistoryFilterModel} from '../../../guests/model'
import {ModalReportFacturation} from '../Modals/ModalReportFacturation'
import {ModalSaveReport} from '../Modals/ModalSaveReport'
import {SelectAsync} from '../../../../../../components/UI/SelectV2'
import {paginationGuestsService} from '../../../guests/services'

interface SelectOption {
  value: string | number | undefined
  label: string | undefined
}

const TableReportFacturation: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination, setClearTable} = useKTable()
  const methods = useForm<BillingModel>({
    resolver: yupResolver(billingSchema),
    defaultValues: {
      ClienteId: '',
      CampamentoId: '',
      ModuloId: '',
      HuespedId: '',
      TipoHabitacionId: '',
      FechaPeriodoIni: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      FechaPeriodoFin: moment().format('YYYY-MM-DD'),
      HuespedDescripcion: 'TODOS',
    },
  })
  const {
    control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    watch,
    reset,
  } = methods
  const [formValue, setFormValue] = useState<any>(null)
  const [formValueLoading, setFormValueLoading] = useState<any>(false)
  const [modules, setModules] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [typeRooms, setTypeRooms] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [client, setClient] = useState<SelectOption[] | any>([{value: '', label: 'TODOS'}])
  const [camps, setCamps] = useState<SelectOption[] | any>([{value: '', label: 'TODOS'}])
  const {getClients, getCamps} = useCentralServices()
  const [showModal, setShowModal] = useState(false)
  const [showModalSave, setShowModalSave] = useState(false)
  const {isAllowed} = useHoteleria()
  const {getModules} = useModules()
  const {getTypeRooms} = useRooms()
  const today = moment().format('YYYY-MM-DD')
  const oneMonthAgo = moment().subtract(1, 'month').format('YYYY-MM-DD')
  ///
  ///

  const columns: Column<BillingDocument>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro Reserva' />,
      accessor: 'NroReserva',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha Estadía' />,
      accessor: 'FechaEstadia',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Empresa' />,
      accessor: 'HuespedEmpresa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Empresa Contratante' />,
      accessor: 'HuespedEmpresaContratante',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cliente' />,
      accessor: 'Cliente_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Campamento' />,
      accessor: 'Campamento_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Módulo' />,
      accessor: 'Modulo_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Habitación' />,
      accessor: 'TipoHabitacion_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Habitación' />,
      accessor: 'Habitacion_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Cama' />,
      accessor: 'Cama_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo Doc. Principal' />,
      accessor: 'TipoDocPrincipal',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro Doc. Principal' />,
      accessor: 'NroDocPrincipal',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nombres' />,
      accessor: 'HuespedNombres',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Apellidos' />,
      accessor: 'HuespedApellidos',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Centro de Costos' />,
      accessor: 'CentroCostos',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Costo Fijo' />,
      accessor: 'Costo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha CheckIn' />,
      accessor: 'FechaCheckIn',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha CheckOut' />,
      accessor: 'FechaCheckOut',
    },
  ]

  const getModulesFn = async (campId: string) => {
    const data = await getModules({CampamentoId: campId, ClienteId: watch('ClienteId')})
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setModules(allData)
  }

  const getTypeRoomsFn = async () => {
    const data = await getTypeRooms()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setTypeRooms(allData)
  }

  const getCampsFn = async (clientId: string) => {
    const data = await getCamps({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
      await getModulesFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCamps(allData)
  }

  const getClientsFn = async () => {
    const data = await getClients({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})
      await getCampsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setClient(allData)
  }

  const loadOptions = async (inputValue: string) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 500,
        isCombo: true,
        BuscaTexto: inputValue,
        ...obj,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno} ${guest.NumeroDocumento}`,
          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }

  const getBillings = async () => {
    try {
      if (!formValue) return
      setLoading(true)
      const obj = {...formValue}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const {data: response} = await getListBillingService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...obj,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getTypeRoomsFn()
    getClientsFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])
  useEffect(() => {
    if (formValueLoading) {
      setFormValueLoading(false)
      if (pagination.currentPage === 1) {
        getBillings()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValueLoading])

  const handleClear = () => {
    reset()
    setFormValue(null)
    setData([])
    setPagination({
      ...pagination,
      currentPage: 1,
      perPage: 10,
      totalResults: 0,
    })
    setCamps([{value: '', label: 'TODOS'}])
    setModules([{value: '', label: 'TODOS'}])
    // setGuests([{value: '', label: 'TODOS'}])
    setClearTable(true)
  }

  const onSubmit = (dataForm: HistoryFilterModel) => {
    setFormValue(dataForm)
    setFormValueLoading(true)
  }

  const handleChangeDateIni = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaPeriodoIni', value)
    setError('FechaPeriodoIni', {})
  }

  const handleChangeDateFin = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaPeriodoFin', value)
    setError('FechaPeriodoFin', {})
  }

  const handleExport = () => {
    setShowModal(true)
  }

  const handleSaveReport = () => {
    setShowModalSave(true)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    getCampsFn(value)
    setModules([{value: '', label: 'TODOS'}])
    setValue('CampamentoId', '')
    setValue('ModuloId', '')
    setValue('HuespedId', '')
    setValue('HuespedDescripcion', 'TODOS')
    setValue('ClienteId', value)
    setError('ClienteId', {})
  }

  const handleCampChange = (val: any) => {
    let value = val ? val.value : ''
    getModulesFn(value)
    setValue('ModuloId', '')
    setValue('HuespedId', '')
    setValue('HuespedDescripcion', 'TODOS')
    setValue('CampamentoId', value)
    setError('CampamentoId', {})
  }

  const handleModuleChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ModuloId', value)
    setValue('HuespedId', '')
    setValue('HuespedDescripcion', 'TODOS')
    setError('ModuloId', {})
  }

  const handleGuestChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('HuespedId', value)
    setValue('HuespedDescripcion', val.label)
    setError('HuespedId', {})
  }

  const handleRoomTypeChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('TipoHabitacionId', value)
    setError('TipoHabitacionId', {})
  }

  useEffect(() => {
    getBillings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  return (
    <>
      <KTCard shadow className='m-5'>
        {isAllowed('BUSCAR_ENCABEZADO') && (
          <>
            <FormProvider {...methods}>
              <form className='m-2'>
                <div className='row'>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Fecha Inicio Estadía:</label>
                    <InputDate
                      name='FechaPeriodoIni'
                      register={register}
                      errors={errors}
                      minValue={oneMonthAgo}
                      maxValue={today}
                      // defaultValue={moment().format('YYYY-MM-DD')}
                      onChange={handleChangeDateIni}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Fecha Fin Estadía:</label>
                    <InputDate
                      name='FechaPeriodoFin'
                      register={register}
                      errors={errors}
                      maxValue={today}
                      // defaultValue={moment().format('YYYY-MM-DD')}
                      onChange={handleChangeDateFin}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Cliente:</label>
                    <Select
                      control={control}
                      name='ClienteId'
                      data={client}
                      errors={errors}
                      onChangeValue={handleClientChange}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Campamento:</label>
                    <Select
                      control={control}
                      name='CampamentoId'
                      data={camps}
                      errors={errors}
                      onChangeValue={handleCampChange}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Módulo:</label>
                    <Select
                      control={control}
                      name='ModuloId'
                      data={modules}
                      errors={errors}
                      onChangeValue={handleModuleChange}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Huésped: (Escriba para buscar un huésped)</label>
                    <SelectAsync
                      loadOptions={loadOptions as any}
                      name='HuespedId'
                      value={{
                        value: watch('HuespedId') || '',
                        label: watch('HuespedDescripcion') || '',
                      }}
                      onChangeValue={handleGuestChange}
                      textPlaceholder='Buscar Huésped...'
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Tipo de Habitación:</label>
                    <Select
                      control={control}
                      name='TipoHabitacionId'
                      data={typeRooms}
                      errors={errors}
                      onChangeValue={handleRoomTypeChange}
                    />
                  </div>
                </div>
              </form>
              <ButtonWrapper className={'sdx-white-bg'}>
                <Button label='Generar' onClick={handleSubmit(onSubmit)} />
                <Button label='Limpiar' onClick={handleClear} />
                <Button label='Exportar' onClick={handleExport} disabled={data.length < 1} />
                <Button
                  label='Guardar Reporte'
                  onClick={handleSaveReport}
                  disabled={data.length < 1}
                />
              </ButtonWrapper>
            </FormProvider>
          </>
        )}
        {isAllowed('LISTAR') && (
          <>
            {loading ? <KTableLoading title='Cargando...' /> : null}
            <KTable data={data} columns={columns as any} />
          </>
        )}
        <ModalReportFacturation
          show={showModal}
          setShow={setShowModal}
          itemToEdit={{pageNumber: pagination.currentPage, size: pagination.perPage, ...formValue}}
        />
        {showModalSave ? (
          <ModalSaveReport
            show={showModalSave}
            setShow={setShowModalSave}
            itemToEdit={formValue}
            client={client}
            camps={camps}
            modules={modules}
            guests={[{value: watch('HuespedId'), label: watch('HuespedDescripcion')}]}
            typeRooms={typeRooms}
          />
        ) : (
          <></>
        )}
      </KTCard>
    </>
  )
}

const TableReportFacturationWrapper = () => {
  return (
    <KTableProvider>
      <div className=''>
        <TableReportFacturation />
      </div>
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableReportFacturationWrapper}
